import React from 'react';
import { Container, Form, Button, Card, Row, Col, Badge } from 'react-bootstrap';
import { FaUserTie, FaArrowLeft, FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const RegisterMentor = () => {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Заявка отправлена! После проверки администратором вы появитесь в каталоге.");
    navigate('/students'); // Возвращаем пользователя на страницу программы
  };

  return (
    <div className="bg-light min-vh-100 pb-5">
      <div className="bg-white border-bottom py-3 mb-5 sticky-top shadow-sm">
      </div>

      <Container>
        <Row className="justify-content-center">
          <Col lg={8} xl={7}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                {/* Декоративная полоса сверху */}
                <div style={{ height: '6px', backgroundColor: '#dc3545' }}></div>

                <Card.Body className="p-4 p-md-5">
                  <div className="text-center mb-5">
                    <div className="bg-danger bg-opacity-10 d-inline-block p-4 rounded-circle mb-3 text-danger">
                      <FaUserTie size={45} />
                    </div>
                    <h2 className="fw-bold">Стать наставником</h2>
                    <p className="text-muted small mx-auto" style={{ maxWidth: '400px' }}>
                      Ваш профессиональный опыт поможет студентам ОшТУ построить успешную карьеру
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3 mb-4">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="small fw-bold text-muted text-uppercase">ФИО полностью</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Асанов Асан"
                            className="bg-light border-0 py-2 px-3 rounded-3"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="small fw-bold text-muted text-uppercase">Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="example@mail.com"
                            className="bg-light border-0 py-2 px-3 rounded-3"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="small fw-bold text-muted text-uppercase">Год выпуска из ОшТУ</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Напр: 2015"
                            className="bg-light border-0 py-2 px-3 rounded-3"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="small fw-bold text-muted text-uppercase">Место работы и должность</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Напр: Ведущий инженер в Ошэлектро"
                            className="bg-light border-0 py-2 px-3 rounded-3"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="small fw-bold text-muted text-uppercase">Ваши компетенции</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Энергетика, Автоматизация, Python, Управление проектами..."
                            className="bg-light border-0 py-2 px-3 rounded-3"
                          />
                          <Form.Text className="text-muted extra-small">
                            Укажите через запятую навыки, которыми вы готовы делиться.
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                    
                    <div className="bg-light p-3 rounded-4 mb-4 border-start border-4 border-danger">
                      <div className="d-flex align-items-center">
                        <FaCheckCircle className="text-danger me-2" />
                        <span className="small text-muted">Ваша анкета пройдет проверку модератором (2-5 дня).</span>
                      </div>
                    </div>

                    <Button
                      variant="danger"
                      type="submit"
                      className="w-100 rounded-pill py-3 fw-bold shadow-sm transition-hover"
                    >
                      Отправить анкету на модерацию
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RegisterMentor;